import classNames from 'classnames';

export const StatDivider = ({ className = '' }: { className?: string }) => (
  <div className={classNames('h-[53px] w-px self-center border-r border-cf-gray-4', className)} />
);
